import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface NotificationIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Notification icon using SF Pro font symbol (􀈄)
 *
 * This icon represents notifications or alerts,
 * used in the pairing help view to indicate that a notification appears on the phone.
 *
 * @example
 * ```tsx
 * <NotificationIcon />
 * <NotificationIcon size={16} weight="regular" />
 * ```
 */
export const NotificationIcon = React.forwardRef<HTMLSpanElement, NotificationIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀈄" {...props} />
  }
)

NotificationIcon.displayName = "NotificationIcon"
